<template>
  <v-layout column :justify-space-between="$vuetify.breakpoint.xsOnly" :justify-start="$vuetify.breakpoint.smAndUp" fill-height>
    <v-fade-transition>
      <v-icon v-if="showArrow && !hideArrow" style="position: fixed; bottom: 10px; left: 50%; transform: translateX(-50%); z-index: 100;" large color="white">keyboard_arrow_down</v-icon>
    </v-fade-transition>
    <v-form ref="form" @keyup.enter.prevent="requestRefund()">
      <v-layout row wrap>
        <v-flex xs6 md3 class="py-0">
          <v-select
            autofocus
            :label="$t('bank_data.document_type')"
            box
            dark
            item-color="primary"
            :items="availableDocumentTypes.map((type) => { return { key: type, text: $t(`bank_data.document_types.${type}`)}})"
            class="flex-none"
            item-text="text"
            item-value="key"
            color="white"
            @change="bankData.document = null"
            :rules="[rules.required]"
            v-model="bankData.documentType"
            :error-messages="formErrors ? formErrors.document_type : ''"
          >
          <div class="pa-2" style="width: 100%; border-radius: 3px;" :class="{'primary--text grey lighten-3': bankData.documentType === data.item.key}" slot="item"  slot-scope="data">{{data.item.text}}</div>
          </v-select>
        </v-flex>
        <v-flex xs6 md3 class="py-0">
          <v-text-field
            :label="$t('bank_data.document')"
            box
            dark
            type="text"
            class="flex-none"
            v-mask="documentMask"
            color="white"
            :rules="[rules.required, rules.document]"
            autocomplete="off" autocorrect="off" spellcheck="false"
            v-model="bankData.document"
            :error-messages="formErrors ? formErrors.document : ''"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 class="py-0">
          <v-text-field
            :label="$t('bank_data.name')"
            box
            dark
            type="text"
            class="flex-none"
            color="white"
            :rules="[rules.required]"
            autocomplete="off" autocorrect="off" spellcheck="false"
            v-model="bankData.name"
            :error-messages="formErrors ? formErrors.name : ''"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 class="py-0">
          <v-text-field
            :label="$t('bank_data.surname')"
            box
            dark
            type="text"
            class="flex-none"
            color="white"
            :rules="[rules.required]"
            autocomplete="off" autocorrect="off" spellcheck="false"
            v-model="bankData.surname"
            :error-messages="formErrors ? formErrors.surname : ''"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 class="py-0">
          <v-text-field
            :label="$t('bank_data.second_surname')"
            box
            dark
            type="text"
            class="flex-none"
            color="white"
            autocomplete="off" autocorrect="off" spellcheck="false"
            v-model="bankData.secondSurname"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 class="py-0">
          <v-text-field
            :label="$t('bank_data.phone')"
            box
            dark
            type="tel"
            class="flex-none"
            color="white"
            :hint="$t('bank_data.hint.phone')"
            :rules="[rules.required, rules.phone]"
            autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
            v-model="bankData.phone"
            :error-messages="formErrors ? formErrors.phone : ''"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 class="py-0">
          <v-text-field
            :label="$t('bank_data.email')"
            box
            dark
            type="email"
            class="flex-none"
            color="white"
            :rules="[rules.required, rules.email]"
            autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
            v-model="bankData.email"
            :error-messages="formErrors ? formErrors.email : ''"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6 class="py-0">
          <v-text-field
            :label="$t(`bank_data.account_types.${availableBankAccountType}`)"
            box
            dark
            type="text"
            class="flex-none"
            color="white"
            :rules="[rules.required, rules.bankNumber]"
            autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
            v-model="bankData.bankAccountNumber"
            :v-mask="availableBankAccountType === 'IBAN' ? 'AA## XXXX XXXX XXXX XXXX XXXX XXXX XXXX XX' : null"
            @keyup.enter.prevent="requestRefund()"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-form>
    <v-flex class="flex-none pa-0">
      <p class="ma-2"><b>{{$t('warnings.important')}}</b>{{$t('warnings.complete_name')}}</p>
      <v-btn class="multiple-lines" :loading="state.loading" style="float: right" :block="$vuetify.breakpoint.xsOnly" color="secondary blue-grey--text text--darken-2" round large :class="{'mt-5': $vuetify.breakpoint.smAndUp}" @click="requestRefund()">{{$t('bank_data.confirm_refund', { amount: formattedTotal })}}</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import routeNames from '@/router/route-names'
import { mapState } from 'vuex'
import ResponsivityMixins from '@/mixins/Responsivity'
import { mask } from 'vue-the-mask'
import { documentTypes } from '@/config'

export default {
  data () {
    return {
      routeNames,
      documentTypes,
      bankData: {
        document: null,
        name: null,
        surname: null,
        secondSurname: null,
        phone: null,
        email: null,
        bankAccountNumber: null,
        documentType: null
      },
      formErrors: null,
      rules: {
        required: (value) => {
          return !!value || this.$t('error.bad_request.any.required')
        },
        bankNumber: (value) => {
          switch (this.availableBankAccountType) {
            case 'IBAN':
              return window.IBAN.isValid(value) || this.$t('error.bad_request.iban.invalid')
            case 'CBU':
              return window.CBU.isValid(value) || this.$t('error.bad_request.cbu.invalid')
            case 'CLABE':
              return window.CLABE.validate(value).ok || this.$t('error.bad_request.clabe.invalid')
            case 'UYU_ACCOUNT':
              return value.length === 14 || this.$t('error.bad_request.uyu_account.invalid')
            default:
              return true
          }
        },
        phone: (value) => {
          try {
            const phone = window.phoneUtil.parse(value || '')
            return (!!value && window.phoneUtil.isValidNumber(phone)) || this.$t('error.bad_request.phone.invalid')
          } catch (error) {
            return this.$t('error.bad_request.phone.invalid')
          }
        },
        email: (value) => {
          // eslint-disable-next-line
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return (!value || re.test(value)) || this.$t('error.bad_request.email.invalid')
        },
        document: (value) => {
          if (this.bankData.documentType && this.bankData.documentType === 'ARG_TAX_DOCUMENT'){
            return window.CUIT.isValid(value) || this.$t('error.bad_request.cuil_cuit.invalid')
          } 
          else if (this.bankData.documentType && this.bankData.documentType === 'MEXICAN_RFC'){
            return window.RFC(value).isValid || this.$t('error.bad_request.mexican_rfc.invalid')
          } else return true
        }
      },
      documentMask: {
        mask: ['DDDDDDDDDDDDDDDDDDDDDDDDDDDD'],
        tokens: {
          D: {
            pattern: /[0-9a-zA-Z]/,
            transform: v => v.toLocaleUpperCase()
          }
        }
      }
    }
  },
  directives: {
    mask
  },
  mixins: [
    ResponsivityMixins
  ],
  methods: {
    pad (str) {
      str = str.toString()
      return str.length < 2 ? this.pad('0' + str) : str
    },
    requestRefund () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('requestRefund').then(() => {
          this.$emit('nextStep')
        }).catch(() => {})
      }
    }
  },
  computed: {
    ...mapState(['state', 'data', 'configuration']),
    formattedTotal () {
      return `${Math.trunc(this.data.userData.refundableBalance / 100)}${this.$t('decimal_separator')}${this.pad(this.data.userData.refundableBalance % 100)} ${this.configuration.configuration.currency}`
    },
    availableDocumentTypes (){
      return this.configuration.configuration.availableDocumentTypes ? this.configuration.configuration.availableDocumentTypes : this.documentTypes
    },
    availableBankAccountType(){
      return this.configuration.configuration.bankAccountType
    }
  },
  watch: {
    bankData: {
      handler: function (value) {
        this.$store.commit('saveBankData', value)
      },
      deep: true
    }
  }
}
</script>
